module.exports = __webpack_public_path__ + "static/media/loading.f8c134b1.svg";